export const APP_TOASTER_ID = 'app-toast';
